import React, { useLayoutEffect } from "react";

import { reloadPage } from "../../utils";

const Sitemap = () => {
    useLayoutEffect(function redirectToRubyPage() {
        if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
          // window.location.replace(`http://localhost:3001${window.location.pathname}`);
        } else {
          window.history.pushState('service_react', '', window.location.pathname);
          //window.history.back();
          reloadPage();
        }
      });

    return (<div>
    </div>);
}

export default Sitemap;
